module.exports = __webpack_public_path__ + "static/media/p_5.4b442eec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/sections/p_5.jpg
// module id = 1096
// module chunks = 0